<template>
    <div>
        
        <breadcrumb :routerList="[{to:'/yuce/sellOn_list',title:'市场预测'},{title:'内销预测详情'}]"/>
        <div class="h-content">
            <div class="h-table h-mrt30">
                <el-table
                        ref="multipleTable"
                        :data="tableData"
                        stripe
						border
                        style="width: 100%">
                    <el-table-column
                            fixed
                            type="index"
                            width="40"
                            label="#">
                    </el-table-column>
                    <el-table-column
                            prop="customer"
                            label="客户名称"
                            :show-overflow-tooltip="true"
                            min-width="180">
								<template slot-scope="scope">
								    <div style="text-align: left;">
								        {{scope.row.customer}}
								    </div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="trench"
                            label="渠道"
                            :show-overflow-tooltip="true"
                            width="80">
                        <template slot-scope="scope">
                            <dictname category="sales_region"  :v="scope.row.trench"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="targetUser"
                            label="目标用户"
                            :show-overflow-tooltip="true"
                            min-width="140">
								<template slot-scope="scope">
								    <div style="text-align: left;">
								        {{scope.row.targetUser}}
								    </div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="productType"
                            label="产品大类"
                            :show-overflow-tooltip="true"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="productModel"
                            label="型号"
                            :show-overflow-tooltip="true"
                            min-width="140">
							<template slot-scope="scope">
							    <div style="text-align: left;">
							        {{scope.row.productModel}}
							    </div>
							</template>
                    </el-table-column>
                    <el-table-column
                            prop="num"
                            label="数量"
                            :show-overflow-tooltip="true"
                            width="60">
								<template slot-scope="scope">
								    <div style="text-align: right;">
								        {{scope.row.num}}
								    </div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="price"
                            label="单价(元)"
                            :show-overflow-tooltip="true"
                            width="90">	
							<template slot-scope="scope">
							    <div style="text-align: right;">
							        {{scope.row.price}}
							    </div>
							</template>
                    </el-table-column>
                    <el-table-column
                            prop="totalSales"
                            label="总销额(元)"
                            :show-overflow-tooltip="true"
                            width="100">
								<template slot-scope="scope">
								    <div style="text-align: right;">
								        {{scope.row.totalSales}}
								    </div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="income"
                            label="收入(元)"
                            :show-overflow-tooltip="true"
                            width="100">
								<template slot-scope="scope">
								    <div style="text-align: right;">
								        {{scope.row.income}}
								    </div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="formationTime"
                            label="预计成单日期"
                            :show-overflow-tooltip="true"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="cdate"
                            label="创建时间"
                            :show-overflow-tooltip="true"
                            width="160">
                    </el-table-column>
                    <el-table-column
                            prop="orderType"
                            label="订单类型"
                            :show-overflow-tooltip="true"
                            width="90">
                        <template slot-scope="scope">
                            <dictname category="yuce_type"  :v="scope.row.orderType"/>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableSummary">
                    <div class="h-tSummaryItem">
                        <span style="height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;">履约率</span>
                        <span v-if="showNum" style="color: #c61c1c;height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;" class="h-redFont">警示（0%）</span>
                        <span v-if="showGreen" style="color: #21d06f;height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;" class="h-greenFont">履约（{{numb}}%） </span>
                        <span v-if="showBlue" style="color: #2785e7;height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;" class="h-blueFont">达标（{{numb}}%）</span>
                        <span v-if="showRed" style="color: #c61c1c;height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;" class="h-redFont">警示（{{numb}}%）</span>
                    </div>
                    <div class="h-tSummaryItem">
                        <span style="height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;">签约目标</span>
                        <span style="height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;">{{target}}万</span>
                    </div>
                    <div class="h-tSummaryItem">
                        <span style="height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;">销单预测金额</span>
                        <span style="height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;">{{totalMon}}万</span>
                    </div>
                </div>
            </div>
            <div class="h-table h-mrt30    bbbb" v-if="showText" style="margin: 0;margin-top: 0.3rem;">
                <div class="h-pieceTitle2 hang">
                    <h1 class="h1">审批意见</h1>
                    <el-form
                            :model="formLabelAlign"
                            label-position="right"
                            :inline="true"
                            class="demo-ruleForm h-formbLine inputO">
                        <el-form-item
                                label="审批意见"
                                class="h-elformWrap-2 "
                                :required="true"
                                style="margin:7px 0 26px 25px">
                            <el-input
                                    v-model="shenhetext"
                                    placeholder="请输入"
                                    class="zidaoO">
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="apprButton" style="margin-top: 0.5rem">
                <el-row>
                    <el-button class=" h-btn h-bBtn h-bgwhite" @click="returnTable">返回</el-button>
                    <el-button v-if="showrefuse" class="el-button h-btn h-bBtn h-bgred el-button--default"
                               @click="auditFail">驳回
                    </el-button>
                    <el-button v-if="showpass" class="el-button h-btn h-bBtn h-bggreen el-button--default"
                               @click="auditPass">通过
                    </el-button>
                    <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default" @click="findDetail">查看审批详情
                    </el-button>
                </el-row>
            </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>

<script>
    import big from 'big.js'
    import ss from '../../../api/SystemService'

    export default {
        data() {
            return {
                code: '',
                shenhetext: '',
                //查询属性
                istrue: false,
                q: {
                    bid: '',
                },
                //表单
                // formInline: {
                //     pageSize: 100,
                //     pageNo: 1,
                //     total: 0,
                // },
                //表格
                tableData: [],
                formLabelAlign: {},
                table: {
                    list: [],
                    optflag: '',
                    yijianMsg: '',
                    aaa: '',
                    taskId: '',
                    instId: ''
                },
                totalMon: 0,
                tot: 0,
                instid: '',
                showhistory: false,
                showText: false,
                showGreen: false,
                showBlue: false,
                showRed: false,
                showNum: true,
                showrefuse: false,
                showpass: false,
                target: 0,
                numb: ''
            }
        },
        mounted() {
            
        },
        created() {
            this.table.taskId = this.$route.query.taskid;
            this.table.instId = this.$route.query.instid;
            this.instid = this.$route.query.instid;
            if (this.$route.query.taskstatus == '0') {
                this.showrefuse = true;
                this.showpass = true;
                this.showText = true;
            }
            this.showList();
        },
        methods: {
            
            
            //查看审批流详情
            findDetail() {
                this.showhistory = true;
            },
            showList() {
                this.q.bid = this.$route.query.ywid;
                ss.pingshen.showYCList(this.q).then(rd => {
                    this.tableData = rd;
                    this.code =  rd[0].cucode;
                    this.totalMon = 0;
                    rd.forEach((item, index) => {
                        this.totalMon = new big(parseInt(this.totalMon)).plus(parseInt(item.totalSales));
                    })
                    this.totalMon = this.totalMon.div(10000);
                    ss.pingshen.showTarget(this.code).then(rd => {
                        this.target = rd;
                        var bid = this.tableData[0].bid;
                        //将签约目标变成万
                        this.target = new big(this.target).div(10000);
                        if (this.target == 0) {
                            this.numb = 100;
                        } else {
                            this.numb = this.totalMon.div(this.target);
                            this.numb = this.numb.times(100);
                            this.numb = this.numb.toFixed(2);
                        }
                        if (this.numb < 70) {
                            this.showRed = true;
                            this.showBlue = false;
                            this.showGreen = false;
                            this.showNum = false;
                        }
                        if (this.numb >= 70 && this.numb < 100) {
                            this.showBlue = true;
                            this.showRed = false;
                            this.showGreen = false;
                            this.showNum = false;
                        }
                        if (this.numb >= 100) {
                            this.showGreen = true;
                            this.showBlue = false;
                            this.showRed = false;
                            this.showNum = false;
                        }
                    })
                })
            },
            showTa() {
                ss.pingshen.showTarget(this.code).then(rd => {
                    this.target = rd;
                })
            },
            auditPass() {
                this.table.aaa = 2
                this.table.optflag = '审核通过';
                this.table.yijianMsg = this.shenhetext;
                this.table.list = this.tableData;
                ss.pingshen.shTG(this.table).then(rd => {
                    this.$msg.msgs(rd.msg);
                })
                //刷新右上角的代办个数
                this.$store.dispatch("searchTasktotal")
                //跳转回系统的代办列表
                this.$router.push({path: '/personal/dealCenter'})
            },
            auditFail() {
                var reg = /^\s$/;
                if (reg.test(this.shenhetext)) {
                    this.$msg.msge("审核意见不能为空!");
                    return;
                }
                if (this.shenhetext == "") {
                    this.$msg.msge("审核意见不能为空!");
                    return;
                }
                this.table.aaa = 1
                this.table.optflag = '审核被驳回';
                this.table.yijianMsg = this.shenhetext;
                this.table.list = this.tableData;
                ss.pingshen.shBTG(this.table).then(rd => {
                    this.$msg.msgs(rd.msg);
                })
                //刷新右上角的代办个数
                this.$store.dispatch("searchTasktotal")
                //跳转回系统的代办列表
                this.$router.push({path: '/personal/dealCenter'})
            },
            returnTable() {
                // this.$router.go(-1);
                this.$router.push({path: '/personal/dealCenter'})
            },
        }
    }
</script>
<style scoped>
    /*--------------- 审批样式 ----------------*/
    .inputO {
        margin-top: 19px;
    }

    .h1 {
        margin: 20px 0 0 31px;
    }

    .bbbb {
        background-color: white;
    }

    .apprButton {
        justify-content: center;
        display: flex;
    }


    /*--------------- 审批样式 ------------------*/
</style>
